import CamposEstadioClub from '../campos/CamposEstadioClub.js';
import TablaEstadiosClubes from '../tablas/TablaEstadiosClubes.js';
import * as Campos from '../../constantes/Campos.js';
import * as FuncionesFecha from '../../funciones/FuncionesFecha.js';

// Funciones para CuadroEditableLista

export const armarFilasTabla = (lista, idElegido, onEditarItem, onEliminarItem) => {
  return (
    <TablaEstadiosClubes
      lista={lista}
      idElegido={idElegido}
      onEditarItem={onEditarItem}
      onEliminarItem={onEliminarItem}
    />
  );
};

export const OrdenarLista = (itemA, itemB) => {
  const fechaDesdeA = FuncionesFecha.CamposToDate(itemA.anioDesde, itemA.mesDesde, itemA.diaDesde);
  const fechaDesdeB = FuncionesFecha.CamposToDate(itemB.anioDesde, itemB.mesDesde, itemB.diaDesde);
  return fechaDesdeA - fechaDesdeB;
};

// Funciones para EditarItemLista

export const CamposEdicion = (idPadre, item, editar, actualizar, onCampoChange, contexto) => {
  return (
    <CamposEstadioClub
      idPadre={idPadre}
      item={item}
      editar={editar}
      actualizar={actualizar}
      onCampoChange={onCampoChange}
      pais={contexto && contexto.pais}
    />
  );
};

export const OnCampoChange = (item, campo, valor) => {
  switch (campo) {
    case Campos.ClubEstadio.CLUB: {
      return { ...item, club: valor };
    }
    case Campos.ClubEstadio.FECHA_DESDE: {
      return {
        ...item,
        anioDesde: valor[FuncionesFecha.ANIO],
        mesDesde: valor[FuncionesFecha.MES],
        diaDesde: valor[FuncionesFecha.DIA],
      };
    }
    case Campos.ClubEstadio.FECHA_HASTA: {
      return {
        ...item,
        anioHasta: valor[FuncionesFecha.ANIO],
        mesHasta: valor[FuncionesFecha.MES],
        diaHasta: valor[FuncionesFecha.DIA],
      };
    }
    default: {
      throw new Error('Campo ' + campo + ' no definido');
    }
  }
};

export const ValidarItemGrabar = (item) => {
  let error = '';
  if (!item) {
    error = 'No se informaron datos para el club';
  } else if (!item.club) {
    error = 'Debe seleccionar el club';
  } else if (
    item.anioDesde &&
    (item.anioDesde < FuncionesFecha.ANIO_MINIMO || item.anioDesde > FuncionesFecha.ANIO_MAXIMO)
  ) {
    error = 'La fecha desde es inválida';
  } else {
    const fechaDesde = item.anioDesde
      ? FuncionesFecha.CamposToFechaBaseInicial(item.anioDesde, item.mesDesde, item.diaDesde)
      : null;
    if (fechaDesde && !fechaDesde < FuncionesFecha.FechaBaseMinima()) {
      error = 'La fecha desde es inválida';
    }
    if (item.anioHasta) {
      if (
        item.anioHasta < FuncionesFecha.ANIO_MINIMO ||
        item.anioHasta > FuncionesFecha.ANIO_MAXIMO
      ) {
        error = 'La fecha hasta es inválida';
      } else if (fechaDesde) {
        const fechaHasta = FuncionesFecha.CamposToFechaBaseFinal(
          item.anioHasta,
          item.mesHasta,
          item.diaHasta
        );
        if (fechaDesde > fechaHasta) {
          error = 'La fecha desde no puede ser posterior a la fecha hasta';
        }
      }
    }
  }
  return error;
};
